import type { NextApiResponse, NextPageContext } from 'next';

import ROUTES from 'Utilities/routes';

export const getServerSideHomePageRedirect = (context: NextPageContext): NextApiResponse => {
	// @ts-expect-error - Property 'redirect' does not exist on type 'ServerResponse<IncomingMessage>'.
	return context.res?.redirect(302, ROUTES.INDEX.href);
};
